var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialImpact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.4,
    cy: 71.53,
    r: 56.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.61,27.14S88.94,32.56,91,36.73s-5,17.92-9.59,20S73.94,68,73.94,73s-3.75,7.08-10.42,1.25-8.7,3.59-8.7,3.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.6,84.66a35.32,35.32,0,0,0,17.51,5.41c10.41.42,13.33,10.84,13.33,25,0,0-.91,5.62,1.17,7.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.62,123.41s-3.34-8.75-15-17.5S114,81.32,118.53,76.32s27.51,5.42,25-7.5-20,1.25-21.67,1.67-2.09-7.09-2.5-12.09a36.63,36.63,0,0,1,.41-9.17L129,48.4c4.58-.42,14.59-.83,15.42-4.59s-1.25-9.16-5.83-8.33,2.91-10,2.91-10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.8,75.44s-18.51-1.62-16.43,5.88,13.39,8.45,13.39,8.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.45,19s-2.12,13.78-.87,21.28c0,0,10.68,1.65,11.52-.43s-3.42-6.17-2.39-10.21C130,16.83,121,14,118.45,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.91,159.26l-14.6-15.82V122.7s-1.07-5.32-5.85-5-6.12,3.46-6.12,5.32v28.18l20.48,23.67.26,26.59h24.2v-33s1.52-4.95-6.65-13.83c-6.88-7.48-19.62-25.08-26.26-16.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.31,159.26l14.61-15.82V122.7s1.06-5.32,5.85-5,6.12,3.46,6.12,5.32v28.18l-20.48,23.67-.27,26.59H126v-33s-1.52-4.95,6.64-13.83c6.89-7.48,19.62-25.08,26.27-16.84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialImpact);
export default __webpack_public_path__ + "static/media/SOCIAL_IMPACT.ed1779add65d257e1a7f64eb2b54bf80.svg";
export { ForwardRef as ReactComponent };